import { useCallback, useContext } from "react";
import {
  Board,
  BoardMachinesStates,
  physicalDetailsLoaded,
  PhysicalDetailsState,
  updatePhysicalDetailsState,
} from "../../../../../reducers/uploadedBoard";
import { useRefreshBoardInStore } from "../boardRefreshes";
import { useAppDispatch } from "../../../store";
import { useDebouncedCallback } from "use-debounce";
import { BoardIdContext, BoardShipmentIds } from "./reviewBoardFlowLoader";

export default function useRefreshPhysicalDetails() {
  const { boardId } = useContext(BoardIdContext) as BoardShipmentIds;
  const dispatch = useAppDispatch();

  const updatePhysicalDetails = useCallback(
    (board: Board) => {
      dispatch(physicalDetailsLoaded({ board }));
    },
    [dispatch],
  );
  const { refreshBoard: refreshPhysicalDetails } = useRefreshBoardInStore(
    updatePhysicalDetails,
  );

  const debouncedRefreshPhysicalDetails = useDebouncedCallback(
    refreshPhysicalDetails,
    10000,
    { leading: true },
  );

  const handlePhysicalDetailsStateUpdates = useCallback(
    (nextStatesData: BoardMachinesStates, states: BoardMachinesStates) => {
      if (
        states.physical_details_datetime_updated !== null &&
        nextStatesData.physical_details_datetime_updated !== null &&
        states.physical_details_datetime_updated <
          nextStatesData.physical_details_datetime_updated
      ) {
        refreshPhysicalDetails();
      } else if (
        nextStatesData.physical_details_state == PhysicalDetailsState.PROCESSING
      ) {
        // If it's still processing, just load less often
        debouncedRefreshPhysicalDetails();
      } else if (boardId) {
        dispatch(
          updatePhysicalDetailsState({
            boardId,
            physicalDetailsState: nextStatesData.physical_details_state,
          }),
        );
      }
    },
    [
      debouncedRefreshPhysicalDetails,
      dispatch,
      refreshPhysicalDetails,
      boardId,
    ],
  );

  return { handlePhysicalDetailsStateUpdates };
}
